import React from 'react'
import { StyledSkillFormItem, Props as StyledSkillFormItemProps } from './styled'

export const SkillFormItem: React.FC<StyledSkillFormItemProps> = (props:StyledSkillFormItemProps) => {

  return (
    <StyledSkillFormItem {...props}/>
  )
}
